import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Truck, ShieldCheck, Users } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-surface py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero */}
        <div className="bg-brand-dark text-white rounded-sm p-12 mb-12 text-center">
          <img
            src="https://customer-assets-lqy194kg.emergentagent.net/job_outils-depot/artifacts/1d0e5f454a2fc444_BATIPRODEAL_logo_vertical_transparent.png"
            alt="BATIPRODEAL"
            className="h-32 w-auto mx-auto mb-6"
          />
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: 'IBM Plex Sans' }}>
            À propos de BATIPRODEAL
          </h1>
          <p className="text-lg max-w-2xl mx-auto text-gray-200">
            Votre partenaire de confiance pour tous vos projets de bricolage et de construction
          </p>
        </div>

        {/* Notre Histoire */}
        <div className="bg-white border border-border rounded-sm p-8 mb-8">
          <h2 className="text-3xl font-bold mb-6 text-brand-orange" style={{ fontFamily: 'IBM Plex Sans' }}>
            Notre Histoire
          </h2>
          <p className="text-foreground mb-4 leading-relaxed">
            BATIPRODEAL est née d'une passion : rendre le bricolage et la construction accessibles à tous,
            qu'il s'agisse de professionnels du bâtiment ou d'amateurs avertis. Implantée au cœur de la France,
            notre société propose une sélection rigoureuse d'outils et matériaux de qualité professionnelle.
          </p>
          <p className="text-foreground leading-relaxed">
            Nous croyons fermement que la qualité ne doit pas être un luxe. C'est pourquoi nous travaillons
            directement avec les meilleurs fabricants pour vous offrir les meilleurs prix sur des produits durables.
          </p>
        </div>

        {/* Nos Valeurs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white border border-border rounded-sm p-6">
            <Award className="w-10 h-10 text-brand-orange mb-4" />
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              Qualité Professionnelle
            </h3>
            <p className="text-muted-foreground">
              Tous nos produits sont sélectionnés pour leur durabilité et leur performance.
              Garantie satisfait ou remboursé sur l'ensemble du catalogue.
            </p>
          </div>
          <div className="bg-white border border-border rounded-sm p-6">
            <Truck className="w-10 h-10 text-brand-orange mb-4" />
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              Livraison Rapide
            </h3>
            <p className="text-muted-foreground">
              Livraison gratuite en 24-48h sur toute la France métropolitaine.
              Suivi en temps réel de votre commande.
            </p>
          </div>
          <div className="bg-white border border-border rounded-sm p-6">
            <ShieldCheck className="w-10 h-10 text-brand-orange mb-4" />
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              Paiement Sécurisé
            </h3>
            <p className="text-muted-foreground">
              Transactions 100% sécurisées par cryptage SSL et système de paiement
              Stripe certifié PCI DSS.
            </p>
          </div>
          <div className="bg-white border border-border rounded-sm p-6">
            <Users className="w-10 h-10 text-brand-orange mb-4" />
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
              Service Client
            </h3>
            <p className="text-muted-foreground">
              Une équipe d'experts disponible pour vous conseiller dans tous vos projets,
              du lundi au samedi de 9h à 18h.
            </p>
          </div>
        </div>

        {/* Chiffres clés */}
        <div className="bg-brand-dark text-white rounded-sm p-8 mb-12">
          <h2 className="text-3xl font-bold text-center mb-8" style={{ fontFamily: 'IBM Plex Sans' }}>
            BATIPRODEAL en chiffres
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-4xl font-bold text-brand-orange mb-2">+5000</div>
              <div className="text-sm text-gray-300">Clients satisfaits</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-orange mb-2">+500</div>
              <div className="text-sm text-gray-300">Produits référencés</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-orange mb-2">48h</div>
              <div className="text-sm text-gray-300">Livraison moyenne</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-orange mb-2">4.7/5</div>
              <div className="text-sm text-gray-300">Note moyenne</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center bg-white border border-border rounded-sm p-8">
          <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'IBM Plex Sans' }}>
            Prêt à démarrer votre projet ?
          </h2>
          <p className="text-muted-foreground mb-6">
            Découvrez notre catalogue complet et trouvez les outils dont vous avez besoin
          </p>
          <Link
            to="/products"
            className="inline-block btn-primary px-8 py-3 rounded-sm font-semibold"
            data-testid="about-cta-button"
          >
            Découvrir nos produits
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
